import {
  NetworkEventData,
  RCEvent,
  EventName,
  EventType,
} from "../../core/eventhub/eventmodels.js";
import { EventController } from "../../core/eventhub/eventcontroller.js";
import { RidecellCallback } from "../../core/models/ridecellcallback.js";
import { CarsharingNetworkRequests } from "../networkrequestsbuilder.js";

const callbackMethod = (resolve, reject) => {
  const marketCallback = new RidecellCallback();
  marketCallback.onSuccess = function success(result) {
    resolve(result);
  };
  marketCallback.onFailure = (error) => {
    reject(error);
  };
  return marketCallback;
};

export class MarketController {
  /**
   * Gets all markets over network.
   *
   * @returns {Market[]} List of all markets
   */
  getMarkets(overrideQueryParams) {
    return new Promise((resolve, reject) => {
      const queryParams = {
        page: 1, //Gets the first page
        page_size: 100, // Using a sufficiently large value to get all markets
        role: "CUSTOMER",
        ...overrideQueryParams,
      };

      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.markets,
        queryParams //queryData
      );

      this.sendEvent(
        new RCEvent(EventName.NETWORK, requestData, callbackMethod(resolve, reject))
      );
    });
  }

  /**
   * Get a market by id
   *
   * @returns {MarketResponse}
   */
  getMarket({ marketID }) {
    return new Promise((resolve, reject) => {

      const requestData = new NetworkEventData(
        EventType.GET,
        CarsharingNetworkRequests.getMarket(marketID),
      );

      this.sendEvent(
        new RCEvent(EventName.NETWORK, requestData, callbackMethod(resolve, reject))
      );
    });
  }

  sendEvent(event) {
    EventController.addEvent(event);
  }
}
